var _path, _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadarChartPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 182,
    viewBox: "0 0 180 182",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9991 0L0 68.755L34.3765 180H145.623L180 68.755L89.9991 0ZM91.0203 8.33596L171.706 69.9713L151.13 74.8284C150.477 73.169 148.925 71.9957 147.109 71.9957C146.732 71.9957 146.374 72.064 146.025 72.1558L94.2249 26.269C94.3029 25.9254 94.3549 25.5721 94.3549 25.205C94.3549 23.0478 92.9308 21.2518 91.0203 20.7677V8.33596ZM120.486 147.101L51.4654 156.439C51.3188 156.122 51.1368 155.83 50.927 155.558L62.4997 136.833C62.936 136.985 63.3965 137.088 63.8829 137.088C66.2892 137.088 68.2406 135.037 68.2406 132.508C68.2406 132.505 68.2406 132.501 68.2406 132.501L104.637 123.032C105.395 124.379 106.776 125.297 108.375 125.297C109.002 125.297 109.595 125.153 110.131 124.901L121.767 143.722C120.97 144.554 120.478 145.702 120.478 146.97C120.475 147.017 120.486 147.062 120.486 147.101ZM63.7845 82.8617C63.6936 82.4088 63.5246 81.9891 63.3185 81.5967L87.1899 63.363C87.7005 63.8159 88.3039 64.1556 88.9761 64.3274V88.7906L63.7845 82.8617ZM88.4617 90.8717L65.3776 128.223C65.1195 128.124 64.8521 128.052 64.5736 128.003L60.9958 88.1034C62.3103 87.6037 63.3204 86.4675 63.7029 85.0424L88.4617 90.8717ZM85.6433 59.8861C85.6433 60.5069 85.7621 61.0946 85.9756 61.6334L61.9371 79.9998C61.2465 79.5156 60.4184 79.2287 59.5272 79.2287C58.1142 79.2287 56.8703 79.9451 56.0756 81.0442L36.1626 76.3589C36.1162 76.1461 36.0531 75.9392 35.9788 75.742L88.2761 29.4121C88.5007 29.5116 88.7365 29.5839 88.9761 29.6483V55.4507C87.0674 55.9309 85.6433 57.727 85.6433 59.8861ZM36.1162 78.5493L55.2401 83.053C55.2011 83.301 55.1677 83.5489 55.1677 83.8085C55.1677 86.1336 56.8238 88.037 58.959 88.3299L62.5313 128.175C60.7897 128.774 59.5216 130.478 59.5216 132.51C59.5216 133.752 59.9951 134.871 60.7563 135.696L49.2968 154.237C49.0685 154.133 48.8271 154.053 48.5802 153.993L34.707 80.8763C35.3866 80.2789 35.8841 79.4727 36.1162 78.5493ZM107.257 116.307L91.6608 91.0708L116.358 85.2434C116.661 86.2078 117.246 87.0434 118.031 87.6037L109.186 116.227C108.921 116.176 108.649 116.139 108.373 116.139C107.981 116.139 107.613 116.206 107.257 116.307ZM111.75 123.575C112.352 122.79 112.725 121.803 112.725 120.715C112.725 119.255 112.066 117.97 111.054 117.131L119.953 88.3357C120.126 88.3592 120.296 88.3885 120.475 88.3885C122.879 88.3885 124.83 86.3367 124.83 83.8085C124.83 83.6172 124.797 83.4357 124.777 83.2483L143.355 78.8655C143.719 79.5254 144.227 80.074 144.847 80.4742L125.683 142.484C125.406 142.43 125.122 142.393 124.829 142.393C124.37 142.393 123.937 142.49 123.522 142.625L111.75 123.575ZM91.0203 29.6463C91.2635 29.5819 91.4993 29.5097 91.7239 29.4101L143.065 74.8908C142.868 75.414 142.749 75.9821 142.749 76.5795C142.749 76.6556 142.768 76.7279 142.772 76.8001L124.06 81.2199C123.276 80.0232 121.96 79.2326 120.473 79.2326C119.582 79.2326 118.752 79.5156 118.061 79.9998L94.0225 61.6334C94.2323 61.0965 94.3549 60.5089 94.3549 59.8861C94.3549 57.7289 92.9308 55.9329 91.0203 55.4487V29.6463ZM91.0203 64.3294C91.6942 64.1576 92.2977 63.8179 92.8082 63.365L116.68 81.6026C116.44 82.0555 116.267 82.5474 116.184 83.0823L91.0184 89.0229L91.0203 64.3294ZM105.454 117.338C104.574 118.179 104.015 119.374 104.015 120.715C104.015 120.803 104.036 120.887 104.039 120.971L67.7374 130.416C67.5592 130.053 67.342 129.721 67.0802 129.416L89.9991 92.3358L105.454 117.338ZM88.9761 8.33596V20.7657C87.0674 21.2499 85.6433 23.0459 85.6433 25.2031C85.6433 25.5701 85.6953 25.9235 85.7733 26.267L33.049 72.9738C32.6888 72.8703 32.3156 72.7981 31.9238 72.7981C30.5369 72.7981 29.3152 73.4911 28.5187 74.5551L8.4702 69.8366L88.9761 8.33596ZM7.01827 71.7029L27.6442 76.5561C27.5978 76.8235 27.5662 77.0968 27.5662 77.3799C27.5662 79.5449 28.9977 81.3488 30.9175 81.8251L44.7869 154.918C43.8252 155.757 43.1995 157.007 43.1995 158.426C43.1995 159.769 43.7565 160.962 44.6291 161.801L38.1177 172.334L7.01827 71.7029ZM39.5957 173.893L46.4283 162.836C46.7885 162.94 47.1635 163.012 47.5553 163.012C49.2151 163.012 50.6411 162.024 51.3763 160.589L122.686 150.943C123.321 151.324 124.045 151.56 124.829 151.56C125.386 151.56 125.913 151.439 126.403 151.24L140.404 173.893H39.5957ZM141.882 172.332L128.078 150.002C128.759 149.19 129.184 148.144 129.184 146.974C129.184 146.406 129.071 145.867 128.895 145.362L148.854 80.7709C150.28 80.115 151.29 78.6703 151.429 76.9621L172.922 71.8864L141.882 172.332Z",
    fill: "#868E96"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8999,
    cy: 132.3,
    r: 4.5,
    fill: "#373D43"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 120.6,
    r: 4.5,
    fill: "#373D43"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.6,
    cy: 83.7,
    r: 4.5,
    fill: "#373D43"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 59.4,
    r: 4.5,
    fill: "#373D43"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.3999,
    cy: 83.7,
    r: 4.5,
    fill: "#373D43"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.95,
    cy: 76.95,
    rx: 4.95,
    ry: 4.95,
    fill: "#868E96"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.95,
    cy: 68.85,
    rx: 4.95,
    ry: 4.95,
    fill: "#ADB5BD"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5501,
    cy: 4.95,
    rx: 4.95,
    ry: 4.95,
    fill: "#ADB5BD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.05,
    cy: 68.85,
    rx: 4.95,
    ry: 4.95,
    fill: "#ADB5BD"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.65,
    cy: 176.85,
    rx: 4.95,
    ry: 4.95,
    fill: "#ADB5BD"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.45,
    cy: 176.85,
    rx: 4.95,
    ry: 4.95,
    fill: "#ADB5BD"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.5501,
    cy: 25.65,
    rx: 4.95,
    ry: 4.95,
    fill: "#868E96"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.05,
    cy: 76.95,
    rx: 4.95,
    ry: 4.95,
    fill: "#868E96"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.65,
    cy: 146.25,
    rx: 4.95,
    ry: 4.95,
    fill: "#868E96"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.15,
    cy: 157.95,
    rx: 4.95,
    ry: 4.95,
    fill: "#868E96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarChartPreview);
export default __webpack_public_path__ + "static/media/radarChartPreview.0fa1ee8fad6f685c94a0b98416636f8f.svg";
export { ForwardRef as ReactComponent };